export default __webpack_public_path__ + "static/media/instagram.778cd585.png";